import { z } from 'zod';

export const integrationViewSchema = z.enum([
  'whatsapp',
  'meli',
  '2clics',
  'wasi',
  'toppropiedades',
  'kiteprop',
]);

export type IntegrationView = z.infer<typeof integrationViewSchema>;
